import gsap from 'gsap'
import { sel, selAll, mm } from './utils'

export default function Changelog() {
  console.log('changelog')
  const logSec$ = sel('.log-sec')
  if (!logSec$) return
  const navC$a = selAll('.log__nav__c')
  const rtW$ = sel('.log__lo__rt-w')
  const rtItem$a = rtW$.querySelectorAll('.log__rt__item')
  navC$a.forEach((el, i) => {
    if (i === 0) el.classList.add('is--active')
    else el.classList.remove('is--active')

    el.addEventListener('click', function (e) {
      if (this.classList.contains('is--active') && window.matchMedia('(min-width: 769px)').matches) return

      navC$a.forEach((nav) => {
        if (nav === el) return
        nav.classList.remove('is--active')
      })
      this.classList.toggle('is--active')
    })
  })
  rtItem$a.forEach((el, i) => {
    if (i === 0) el.classList.add('is--active')
    else {
      el.classList.remove('is--active')
    }
  })

  mm.add('(max-width: 768px)', () => {
    // Track moved elements to restore them later
    const movedElements = []

    const ctx = gsap.context(() => {
      // Move content elements to their mobile positions
      rtItem$a.forEach((rtItem) => {
        const slug = rtItem.dataset.slug
        const contentElement = rtItem.querySelector('.log__c')
        const targetContainer = sel(`.log__nav__c[data-slug="${slug}"] .log__nav__rt`)

        console.log('targetContainer', targetContainer)
        if (targetContainer) {
          // Store original position before moving
          movedElements.push({
            element: contentElement,
            originalParent: contentElement.parentElement,
            nextSibling: contentElement.nextElementSibling,
          })

          // Move element to new location
          targetContainer.appendChild(contentElement)
        }
      })
    }, logSec$) // Scope to log section

    return () => {
      // Restore all moved elements to their original positions
      movedElements.forEach(({ element, originalParent, nextSibling }) => {
        if (element && originalParent) {
          if (nextSibling) {
            originalParent.insertBefore(element, nextSibling)
          } else {
            originalParent.appendChild(element)
          }
        }
      })
      ctx.revert()
    }
  })
  function desktopNavClickHandler(e) {
    const slug = this.dataset.slug
    const nextPane$ = sel(`.log__rt__item[data-slug="${slug}"]`)
    if (nextPane$.classList.contains('is--active')) return

    const currentPane$ = sel('.log__rt__item.is--active')
    nextPane$.classList.add('is--active')
    currentPane$.classList.remove('is--active')
  }

  navC$a.forEach((nav) => {
    nav.addEventListener('click', desktopNavClickHandler)
    // listeners.push({
    //   element: nav,
    //   type: 'click',
    //   handler: desktopNavClickHandler,
    // })
  })
  mm.add('(min-width: 769px)', () => {
    const listeners = []
    const ctx = gsap.context(() => {}, logSec$) // Scope to log section

    return () => {
      // listeners.forEach(({ element, type, handler }) => {
      //   element.removeEventListener(type, handler)
      // })
      ctx.revert()
    }
  })
}
